import React from "react";
import { useParams } from "react-router-dom";

import DateRangeBar from "ui/DateRangeBar";
import LogInsightsContent from "./LogInsightsContent";
import PageContent from "ui/PageContent";
import { useCurrentServer } from "providers/WithCurrentOrganization";

import directory from "../../../../../docs/directory.json";

import styles from "./style.module.scss";
import { BookIcon } from "ui/Icons";

function LogInsights() {
  const {
    databaseId,
    serverId,
    classification: activeClassification,
  } = useParams();
  // Database-scoped routes have no serverId param; the current server is resolved from the database.
  const server = useCurrentServer();
  const details = activeClassification
    ? directory.logClassifications[
        activeClassification as keyof typeof directory.logClassifications
      ]
    : null;
  const featureInfo = activeClassification ? (
    <>
      <p>
        {details.tooltip}{" "}
        <a
          href={`https://pganalyze.com` + details.path}
          target="_blank"
          className={styles.detailsDocsLink}
        >
          <BookIcon /> Learn more
        </a>
      </p>
    </>
  ) : null;

  return (
    <PageContent
      title={
        activeClassification
          ? `Log Insights - ${activeClassification}: ${details.title}`
          : "Log Insights"
      }
      pageControls={<DateRangeBar feature="Log" />}
      windowTitle="Log Insights"
      pageCategory={serverId ? "server" : "database"}
      pageName="logs"
      featureInfo={featureInfo}
    >
      <LogInsightsContent
        databaseId={databaseId}
        serverId={server.humanId}
        activeClassification={activeClassification}
      />
    </PageContent>
  );
}

export default LogInsights;
